/**
 * Copyright © 2025 Delicious AI, LLC
 *
 * @author Mitch Wilson <mitchell.wilson@deliciousai.com>
 */

import { gql } from '@apollo/client'

import { GROUP_FRAGMENT } from './GroupFragment'
import { STORE_FRAGMENT } from './StoreFragment'
import { USER_FRAGMENT } from './UserFragment'

export const INVITATION_FRAGMENT = gql`
  fragment Invitation on Invitation {
    id
    email
    inviter {
      ...User
    }
    stores {
      ...Store
    }
    groups {
      ...Group
    }
    opened
    invalidated
  }
  ${USER_FRAGMENT}
  ${STORE_FRAGMENT}
  ${GROUP_FRAGMENT}
`
